import { FC, useMemo } from "react";
import OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesDriverTableRow from "../types/order-optimizer-raily-details-hidden-details-heading-tables-driver-table-row";
import orderOptimizerRailyDetailsHiddenDetailsHeadingTablesDriverTableHelper from "./order-optimizer-raily-details-hidden-details-heading-tables-driver-table.helper";
import TableComponent, {
  TableProps,
} from "../../../../../../../common/components/table/table.component";
import dateService from "../../../../../../../common/utils/date/date.service";
import uuidService from "../../../../../../../common/utils/uuid/uuid.service";
import { useAppContext } from "../../../../../../../context/app.context";
import { OrderOptimizerRailyDetailsItemStepsHomeToStart } from "../../../common/types/order-optimizer-raily-details-item";

type OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesDriverTableProps =
  Pick<TableProps, "isError" | "isLoading"> & {
    detailsStepsHomeToStartItem: OrderOptimizerRailyDetailsItemStepsHomeToStart | null;
  };

const OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesDriverTableComponent: FC<
  OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesDriverTableProps
> = (props) => {
  const { selectedAppLanguage } = useAppContext();

  const columns = useMemo(() => {
    return orderOptimizerRailyDetailsHiddenDetailsHeadingTablesDriverTableHelper.getColumns();
  }, [selectedAppLanguage]);

  const createTableRow = (
    detailsStepsHomeToStartItem: OrderOptimizerRailyDetailsItemStepsHomeToStart
  ): OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesDriverTableRow => {
    const totalTimeLabel = dateService.formatTime(
      detailsStepsHomeToStartItem.driverTime
    );
    const totalTimeTitle = dateService.formatTime(
      detailsStepsHomeToStartItem.driverTime
    );

    return {
      id: uuidService.generate(),
      value: {
        totalTime: <div title={totalTimeTitle}>{totalTimeLabel}</div>,
        haltingTime: <div title="00:00 h">00:00 h</div>,
        totalDrivingTime: <div title="00:00 h">00:00 h</div>,
        distance: <div title="0.0 KM">0.0 KM</div>,
      },
    };
  };

  const rows: OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesDriverTableRow[] =
    useMemo(() => {
      if (!props.detailsStepsHomeToStartItem) return [];

      const orderRows = createTableRow(props.detailsStepsHomeToStartItem);

      return [orderRows];
    }, [props.detailsStepsHomeToStartItem, selectedAppLanguage]);

  return (
    <TableComponent
      columns={columns}
      rows={rows}
      isLoading={props.isLoading}
      isError={props.isError}
    />
  );
};

export default OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesDriverTableComponent;
